import "./style.css";
import { SearchBox } from "../SearchBox";

export const Hero = ({ onServiceClick }) => {
  return (
    <section className="hero">
      <div className="hero-container">
        {/* Left Content */}
        <div className="hero-content">
          <h1 className="hero-title">
            Get Your Business Solution in 10 Minutes.<br />
            Hassle-Free Legal & Compliance.
          </h1>

          <p className="hero-subtitle">
            Great Platform for Company Registration, Trademark, and GST Filing,<br />
            backed by expert CAs and Accountants.
          </p>

          <button className="hero-cta" onClick={() => onServiceClick("Company Registration")}>
            Start Your Company Registration Now @2999
          </button>
        </div>

        <div className="hero-right">
          <div className="hero-illustration">
            <div className="person-illustration">
              <div className="person-silhouette">
                <div className="person-head-simple">
                  <div className="hair-top"></div>
                  <div className="face-circle">
                    <div className="eye-dot left"></div>
                    <div className="eye-dot right"></div>
                  </div>
                </div>
                <div className="person-shoulders"></div>
              </div>
              
              {/* Laptop in Front */}
              <div className="laptop-front">
                <div className="laptop-screen-frame">
                  <div className="screen-inner"></div>
                </div>
                <div className="laptop-base"></div>
              </div>
            </div>

            {/* Completed Document Card */}
            <div className="document-card">
              <div className="doc-icon-wrapper">
                <div className="doc-icon">
                  <div className="check-circle">✓</div>
                </div>
              </div>
              <div className="doc-info">
                <div className="doc-title"></div>
                <div className="doc-subtitle"></div>
              </div>
            </div>

            {/* Business Icons Floating */}
            <div className="floating-icon icon-document">
              <div className="icon-circle">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  {/* Building/Company Icon */}
                  <rect x="4" y="4" width="16" height="18" rx="1" fill="#4fa8b8" stroke="#3d8b98" strokeWidth="1"/>
                  {/* Windows */}
                  <rect x="6.5" y="6.5" width="3" height="2.5" fill="white" opacity="0.9"/>
                  <rect x="10.5" y="6.5" width="3" height="2.5" fill="white" opacity="0.9"/>
                  <rect x="14.5" y="6.5" width="3" height="2.5" fill="white" opacity="0.9"/>
                  <rect x="6.5" y="10" width="3" height="2.5" fill="white" opacity="0.9"/>
                  <rect x="10.5" y="10" width="3" height="2.5" fill="white" opacity="0.9"/>
                  <rect x="14.5" y="10" width="3" height="2.5" fill="white" opacity="0.9"/>
                  <rect x="6.5" y="13.5" width="3" height="2.5" fill="white" opacity="0.9"/>
                  <rect x="10.5" y="13.5" width="3" height="2.5" fill="white" opacity="0.9"/>
                  <rect x="14.5" y="13.5" width="3" height="2.5" fill="white" opacity="0.9"/>
                  {/* Door */}
                  <rect x="9.5" y="17" width="5" height="5" fill="#2c3e50"/>
                  {/* Roof Flag */}
                  <line x1="12" y1="4" x2="12" y2="1" stroke="#e74c3c" strokeWidth="1.5"/>
                  <path d="M12 1L16 3L12 4.5V1Z" fill="#e74c3c"/>
                </svg>
              </div>
            </div>
            <div className="floating-icon icon-justice">
              <div className="icon-circle">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L8 6H6L4 12H8L12 8L16 12H20L18 6H16L12 2Z" fill="#6c757d"/>
                  <rect x="4" y="12" width="4" height="2" fill="#6c757d"/>
                  <rect x="16" y="12" width="4" height="2" fill="#6c757d"/>
                  <rect x="11" y="6" width="2" height="16" fill="#6c757d"/>
                  <rect x="8" y="20" width="8" height="2" rx="1" fill="#6c757d"/>
                </svg>
              </div>
            </div>
            <div className="floating-icon icon-check">
              <div className="icon-circle check-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M20 6L9 17L4 12" stroke="#17a2b8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="bg-shape shape-1"></div>
            <div className="bg-shape shape-2"></div>
            <div className="bg-shape shape-3"></div>
          </div>

          <div className="hero-search-wrapper">
            <SearchBox onServiceSelect={onServiceClick} />
          </div>
        </div>
      </div>
    </section>
  );
};


